export default {"src":"/_next/static/media/disability.376a026d.svg","height":65,"width":64,"blurWidth":0,"blurHeight":0};